export const getCertificationDataObject = (type: string) => {
	switch (type) {
		case "CourseContentOnly":
			return {
				CourseContentOnly: {
					kind: "CourseContentOnly" as const,
				},
			};
		case "CertificationUpgrade":
			return {
				CertificationUpgrade: {
					kind: "CertificationUpgrade" as const,
				},
			};
		case "WithCertification":
		default:
			return {
				WithCertification: {
					kind: "WithCertification" as const,
				},
			};
	}
};
